import { CloseOutlined, SaveOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import useStyles from "./styles";

export default function ErpFormModal({
  open,
  erp,
  tiposDisponiveis = [],
  loading,
  onClose,
  onSave,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [form, setForm] = useState({ nome: "", tipo: "", descricao: "" });
  const [tentouSalvar, setTentouSalvar] = useState(false);

  useEffect(() => {
    if (!open) return;
    setTentouSalvar(false);
    setForm({
      nome: erp?.nome || "",
      tipo: erp?.tipo || tiposDisponiveis[0] || "",
      descricao: erp?.descricao || "",
    });
  }, [open, erp]);

  const erros = {
    nome: !form.nome.trim() && "Informe o nome do ERP",
    tipo: !form.tipo && "Selecione o tipo",
  };
  const valido = !erros.nome && !erros.tipo;

  const handleSalvar = () => {
    setTentouSalvar(true);
    if (valido) onSave({ id: erp?.id, ...form });
  };

  const set = (campo) => (e) => setForm({ ...form, [campo]: e.target.value });

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: styles.dialogPaper }}
    >
      <DialogTitle sx={styles.dialogTitle}>
        <Box>
          <Typography sx={styles.titulo}>
            {erp ? "Editar ERP" : "Adicionar ERP"}
          </Typography>
          <Typography sx={styles.subtitulo}>
            Depois de salvar, cadastre os dados de acesso ao banco e à API.
          </Typography>
        </Box>
        <IconButton onClick={onClose} disabled={loading} size="small">
          <CloseOutlined fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={styles.content}>
        <TextField
          select
          label="Tipo de ERP"
          value={form.tipo}
          onChange={set("tipo")}
          disabled={loading || !!erp}
          error={tentouSalvar && !!erros.tipo}
          helperText={
            (tentouSalvar && erros.tipo) ||
            (erp
              ? "O tipo não pode ser alterado depois do cadastro"
              : "Define quais dados de acesso poderão ser configurados")
          }
          size="small"
          fullWidth
        >
          {tiposDisponiveis.map((tipo) => (
            <MenuItem key={tipo} value={tipo}>
              {tipo}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Nome"
          placeholder="Ex.: HubSoft Produção"
          value={form.nome}
          onChange={set("nome")}
          disabled={loading}
          error={tentouSalvar && !!erros.nome}
          helperText={tentouSalvar && erros.nome}
          size="small"
          fullWidth
          autoFocus
        />
        <TextField
          label="Descrição (opcional)"
          value={form.descricao}
          onChange={set("descricao")}
          disabled={loading}
          size="small"
          fullWidth
          multiline
          minRows={2}
        />
      </DialogContent>

      <DialogActions sx={styles.actions}>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleSalvar}
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <SaveOutlined />
            )
          }
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
